<template>
  <main
    class="fixed z-50 left-0 w-full py-1 flex gap-1 items-center justify-center px-5 text-white bg"
    :class="isOnDevEnvironment ? 'top-5' : 'top-0'"
  >
    <p class="text-xs font-thin">
      You have now logged into the business account of
      <span class="font-medium">{{ name }} </span>as an admin
      <span class="font-medium">{{ adminEmail }}</span
      ><span
        class="text-accent-muted underline pl-3 cursor-pointer transition-all duration-300 hover:opacity-80"
        @click="openDialog('showGuideInstruction')"
        >See guidelines.</span
      >
    </p>
    <!-- dialogs -->
    <guide-instruction
      v-if="showGuideInstruction"
      :showDialog="showGuideInstruction"
      @closeDialog="closeDialog('showGuideInstruction')"
    />
  </main>
</template>

<script>
import { ADMIN_EMAIL, ADMIN_BUSINESS_NAME } from '@/utils/constants'
export default {
  components: {
    GuideInstruction: () => import('@/components/base/GuideInstruction.vue')
  },
  data () {
    return {
      name: 'Michael',
      adminEmail: '',
      showGuideInstruction: false
    }
  },
  computed: {
    isOnDevEnvironment () {
      return process.env.NODE_ENV !== 'production'
    }
  },
  methods: {
    closeDialog (arg) {
      this[arg] = false
    },
    openDialog (arg) {
      this[arg] = true
    }
  },
  beforeMount () {
    this.adminEmail = localStorage.getItem(ADMIN_EMAIL)
    this.name = localStorage.getItem(ADMIN_BUSINESS_NAME)
  }
}
</script>

<style scoped>
.bg {
  background: #0f0f1b;
}
</style>
